import { useEffect, useState } from 'react';
import { getIdCatCreditoPrecosecha, useCoopConfig } from '../components/content/coop-config';
import DebtCalculator from '../nuup/utils/debtCalculator';
import Api from '../api/global.service';
import getEstatus from '../nuup/utils/getStatusDebtColor';
import { publish } from '../components/events';

const useCreditosData = ({ uuid_cuenta, id_ciclo, publishEvent }) => {
  const [blockingCreditos, setBlockingCreditos] = useState(true);
  const [creditos, setCreditos] = useState([]);
  const coopConfig = useCoopConfig();

  useEffect(() => {
    getDataCreditos();
  }, []);

  const getDataCreditos = () => {
    setBlockingCreditos(true);
    const interesCoop = coopConfig.catCreditoPrecosecha()?.interes;
    Api.Acopio.search('anticipos', {
      filter: [
        { column: 'id_ciclo', operator: '=', value: id_ciclo },
        { column: 'productor_uuid', operator: '=', value: uuid_cuenta },
      ],
    })
      .then(response => {
        const updatedData = response.data.map(anticipo => {
          const total_anticipos_recuperados = anticipo.anticipo_pagos.reduce((acc, pg) => acc + +pg.cantidad_pago / 100, 0);

          // RETURN DATA WITH DEBT CALCULATION
          if (getIdCatCreditoPrecosecha() > 2) {
            const interes = anticipo.tasa_interes && +anticipo.tasa_interes >= 0 ? +anticipo.tasa_interes * 100 : +interesCoop;
            const debtCalc = new DebtCalculator({
              credito: anticipo,
              interestRate: interes,
              pagos: anticipo.anticipo_pagos,
              stringDate: null,
            });
            const calc = debtCalc.getDebt();
            const estatus = getEstatus(calc.debtToday.pendingCapital / 100);
            return {
              ...anticipo,
              total_anticipos_recuperados,
              total_saldo: calc.debtToday.pendingCapital / 100,
              total: +calc.debtToday.totalInterest / 100 + +anticipo.cantidad_anticipo / 100,
              total_interes: calc.debtToday.totalInterest / 100,
              estatus: estatus.label,
              estatus_color: estatus.color,
              tasa_interes: interes,
            };
          }
          // RETURN DATA WITH NO INTEREST RATE
          const estatus = getEstatus(+anticipo.cantidad_anticipo / 100 - +total_anticipos_recuperados);

          return {
            ...anticipo,
            total: +anticipo.cantidad_anticipo / 100,
            total_interes: 0,
            total_saldo: +anticipo.cantidad_anticipo / 100 - +total_anticipos_recuperados,
            estatus: estatus.label,
            estatus_color: estatus.color,
            comision_efectivo: 999,
          };
        });

        let _creditos_raw = updatedData.map(function(obj) {
          return {
            anticipo_id: obj.id,
            total_saldo: obj.total_saldo,
            fecha_ejecucion: obj.fecha_ejecucion,
          };
        });

        let _creditos = {
          creditos_no: updatedData.length,
          creditos_total:
            updatedData.reduce(function(tot, arr) {
              return tot + arr.total;
            }, 0) -
            updatedData.reduce(function(tot, arr) {
              return tot + arr.total_interes;
            }, 0),
          total_saldo: updatedData.reduce(function(tot, arr) {
            return tot + arr.total_saldo;
          }, 0),
          raw: _creditos_raw,
        };

        setCreditos(_creditos);
        publishEvent && publish(publishEvent, _creditos);

        setBlockingCreditos(false);
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.log('error: ', e);
        setBlockingCreditos(false);
      });
  };

  return {
    blockingCreditos,
    creditos,
  };
};

export default useCreditosData;
